<common-mojo-card>
  <div class="averages-container">
    <div class="averages-label">
      Averages per job
    </div>
    <div
      class="averages-blocks"
      *ngIf="(averagesPerJob$ | async) as averagesPerJob"
    >
      <div class="first-block block">
        <div class="inside-block">
          <div>AVG. APPLICANTS TO</div>
          <div class="hire">HIRE</div>
          <div class="number-container">
            <span class="number">{{averagesPerJob.applicantsToHire}}</span>
            <mat-icon class="arrow">trending_flat</mat-icon>
            <span class="small-text">Hire</span>
          </div>
        </div>
        <div class="block-divider"></div>
        <div class="inside-block">
          <div>AVG. SUBMISSIONS TO</div>
          <div class="hire">HIRE</div>
          <div class="number-container">
            <span class="number">{{averagesPerJob.submissionsToHire}}</span>
            <mat-icon class="arrow">trending_flat</mat-icon>
            <span class="small-text">Hire</span>
          </div>
        </div>
        <div class="block-divider"></div>
        <div class="inside-block">
          <div>AVG. INTERVIEWS TO</div>
          <div class="hire">HIRE</div>
          <div class="number-container">
            <span class="number">{{averagesPerJob.interviewsToHire}}</span>
            <mat-icon class="arrow">trending_flat</mat-icon>
            <span class="small-text">Hire</span>
          </div>
        </div>
      </div>
      <div class="second-block block">
        <div class="inside-block">
          <div>APPLICANTS TO SUBMISSION RATIO</div>
          <div class="number-container">
            <span
              class="number">{{averagesPerJob.applicantsToSubmission}}</span>
            <mat-icon class="arrow">trending_flat</mat-icon>
            <span class="number">1</span>
          </div>
        </div>
      </div>
      <div class="third-block block">
        <div class="inside-block">
          <div>HIRING MANAGER RESPONSE TIME</div>
          <div class="number-container">
            <ng-container
              *ngIf="responseTimeObj.hiringManagerResponseTimeDays > 0"
            >
              <span
                class="number">{{responseTimeObj.hiringManagerResponseTimeDays}}</span>
              <span class="small-text">d</span>
            </ng-container>
            <ng-container
              *ngIf="responseTimeObj.hiringManagerResponseTimeHours > 0"
            >
              <span
                class="number">{{responseTimeObj.hiringManagerResponseTimeHours}}</span>
              <span class="small-text">h</span>
            </ng-container>
            <ng-container
              *ngIf="responseTimeObj.hiringManagerResponseTimeMinutes > 0"
            >
              <span
                class="number">{{responseTimeObj.hiringManagerResponseTimeMinutes}}</span>
              <span class="small-text">min</span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</common-mojo-card>
